import { render, staticRenderFns } from "./DocumentRowDetail.vue?vue&type=template&id=6968fde4"
import script from "./DocumentRowDetail.vue?vue&type=script&lang=js"
export * from "./DocumentRowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6968fde4')) {
      api.createRecord('6968fde4', component.options)
    } else {
      api.reload('6968fde4', component.options)
    }
    module.hot.accept("./DocumentRowDetail.vue?vue&type=template&id=6968fde4", function () {
      api.rerender('6968fde4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documents/batch/components/DocumentRowDetail.vue"
export default component.exports